import { Pipe, PipeTransform } from '@angular/core';
import { highlightAuto } from 'highlight.js';
import { parse, Renderer } from 'marked';

@Pipe({
  name: 'markdown'
})
export class MarkdownPipe implements PipeTransform {
  transform(value: string): string {
    const renderer = new Renderer();
    renderer.link = this.link;

    return value ? parse(value, {
      highlight: this.highlight,
      renderer: renderer,
      }) : value;
  }

  link(href: string, title: string, text: string): string {
    // external = /^https?:\/\/.+$/.test(href);
    // newWindow = external || title === 'newWindow';
    let out = '<a href=\"' + href + '\" target=\"_blank\"';

    if (title) {
      out += ' title=\"' + title + '\"';
    }
    return out += '>' + text + '</a>';
  }


  highlight(code: string, lang: string): string {
    return lang ? highlightAuto(code, [lang]).value : code;
  }
}



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/shared/markdown.pipe.ts